__turbopack_context__.v({
  "page": "page-module__2dhpZa__page",
  "page__avatar": "page-module__2dhpZa__page__avatar",
  "page__background": "page-module__2dhpZa__page__background",
  "page__content": "page-module__2dhpZa__page__content",
  "page__footer": "page-module__2dhpZa__page__footer",
  "page__logo": "page-module__2dhpZa__page__logo",
  "page__watermark": "page-module__2dhpZa__page__watermark",
});
